// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import { ToastContextData } from "@insite/mobius/Toast/ToasterContext";
import DownloadDocumentError from "@store/Library/Components/ProductDetails/DownloadDocumentError";

export interface GetDocumentsWrapperOptions {
    errorMessage?: string;
    stateSetter?: (value: React.SetStateAction<boolean>) => void;
    toasterContext?: ToastContextData;
}

export const getDocumentsWrapper = async <TGetterParams>(
    documentGetter: (params: TGetterParams) => Promise<void>,
    queryParameters: TGetterParams,
    options?: GetDocumentsWrapperOptions,
) => {
    const { errorMessage, stateSetter, toasterContext } = options || {};
    stateSetter?.(true);

    try {
        await documentGetter({ ...queryParameters });
        toasterContext?.addToast({
            body: translate("Document successfully downloaded"),
            messageType: "success",
            timeoutLength: 6000,
        });

        stateSetter?.(false);

        return true;
    } catch (e) {
        if (e.status === 401) {
            window.location.reload();
        } else {
            toasterContext?.addToast({
                body: DownloadDocumentError({
                    message: errorMessage,
                    emailTo: e.errorJson.csrEmail,
                }) as React.ReactNode,
                messageType: "danger",
                timeoutLength: 60000,
            });
        }
        stateSetter?.(false);

        return false;
    }
};
